import { FC, ReactNode, useMemo } from 'react';

import classNames from 'classnames';

import './Menu.scss';

import { TestMetadata } from '../types';

export interface MenuProps {
  /** Elements to Wrap */
  children: ReactNode;
  /** Class name */
  className?: string;
  /** Determines if orientation of menu is horizontal */
  horizontal?: boolean;
  /** Determines if orientation of menu is vertical */
  vertical?: boolean;
  /** Determines if menu is nested within another menu */
  nested?: boolean;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const Menu: FC<MenuProps> = ({
  className,
  horizontal,
  nested,
  vertical,
  testMetadata,
  children,
  ...otherProps
}) => {
  const menuClassNames = useMemo(
    () =>
      classNames(
        'sb-menu',
        {
          'sb-menu_horizontal': horizontal,
          'sb-menu_vertical': vertical,
          'sb-menu__sub-menu': nested,
        },
        className,
      ),
    [className, horizontal, nested, vertical],
  );

  return (
    <ul {...otherProps} className={menuClassNames} {...testMetadata}>
      {children}
    </ul>
  );
};

export default Menu;
